import { SLIDE_WIDTH } from './constants';

export function getSlidesPerView(windowWidth: number | false): number {
  return windowWidth ? parseFloat((windowWidth / SLIDE_WIDTH).toFixed(1.2)) : 0;
}
